import Typed from "./Typed"

// A skill category that gently hovers, with a super-translucent pixel-art icon
// sitting behind crisp text. The outer wrapper applies a scatter offset so the
// categories don't sit on a neat grid; the inner element does the float.
export default function Skills({
    name,
    skills,
    icon,
    delay = 0,
    duration = 7,
    offsetX = 0,
    offsetY = 0,
}) {
    return (
        <div style={{ transform: `translate(${offsetX}px, ${offsetY}px)` }}>
            <div
                className="skill-cloud flex w-64 flex-col items-center justify-center px-4 py-6 text-center"
                style={{ animationDelay: `${delay}s`, animationDuration: `${duration}s` }}
            >
                {icon && (
                    <img
                        src={`/skill-icons/${icon}.svg`}
                        alt=""
                        aria-hidden="true"
                        className="skill-icon"
                    />
                )}

                <Typed
                    text={name}
                    classList="text-3xl font-bold pb-3"
                    blinkTimeout={1500}
                />

                <div className="flex flex-row flex-wrap items-center justify-center">
                    {skills.map((skill) => (
                        <span key={skill} className="px-2 py-1 text-xl opacity-90">
                            {skill}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    )
}
